// extracted by mini-css-extract-plugin
export default {"addRow":"AnnotationURLModal_addRow__tvFCd","URLInputRow":"AnnotationURLModal_URLInputRow__PGs83"};